import React, { Component } from "react";
import { useEffect, useMemo, useState, useRef, useContext } from "react";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import CollegueProfile from "./CollegueProfile";
import "./style.css";
import axios from "axios";
import ReactTooltip from "react-tooltip";
import PuffLoader from "react-spinners/PuffLoader";
import { Context } from "../../themeContext";
import { HashRouter as Router, Switch, Route, Link } from "react-router-dom";
import { withTranslation } from "react-i18next";
import { SettingsSystemDaydreamTwoTone } from "@material-ui/icons";

//const ENDPOINT = "https://192.168.30.40:5004";
const token = localStorage.getItem("AccessToken");
const compte = localStorage.getItem("compte");
const poste = localStorage.getItem("poste");
const BackendURL = window.BackendURLCmk;
var lien = window.location.href;
//console.log(lien);
const var22 = lien.split("/");

function Colleguegroupesmall({ t, collegue }) {
  const [show, setShow] = useState(false);
  const [etat, setetat] = useState("");
  const [encom, setencom] = useState("");
  const [imgsrc, setimgsrc] = useState("");
  const [imgsrc2, setimgsrclien] = useState("");
  const [nom, setnom] = useState("");
  const [state, dispatch] = useContext(Context);

  const hideModal = () => setShow(false);
  const showModal = () => setShow(true);

  function finditemincollegue() {
    const collgtab2 = localStorage.getItem("tabcollegue");
    const collgtab = JSON.parse(collgtab2);
    // console.log(collgtab);
    var index = collgtab.findIndex((x) => x.poste == collegue);
    // console.log(collegue);
    //console.log(collgtab[index]);
    if (collgtab[index] != undefined) {
      setetat(collgtab[index].etat);
      setencom(collgtab[index].encom);
      setimgsrc(collgtab[index].photo_poste_interne);
      setnom(collgtab[index].nom);
      setimgsrclien(collgtab[index].lien_photo_poste_interne);
    }
  }
  const etatPhone1 = (etat, com) => {
    if (etat == "Connecté") {
      if (com == "") {
        return (
          <span>
            {" "}
            <span
              class="absolute top-0.5 left-0.5 block h-2 w-2 rounded-full  opacity-75"
              style={{ backgroundColor: "#62bd19" }}
            ></span>
            <span
              className=" absolute top-0.5 left-0.5 block h-1.5 w-1.5 rounded-full ring-2 ring-white"
              style={{ backgroundColor: "#62bd19" }}
            ></span>
          </span>
        );
      } else if (com !== "") {
        if (com == "Sonnerie") {
          return (
            <span>
              <span class="animate-ping absolute top-0.5 left-0.5 inline-flex h-2 w-2 rounded-full bg-yellow-500 opacity-95"></span>
              <span class="absolute top-0 left-0 block h-1.5 w-1.5 rounded-full h-1.5 w-1.5 bg-yellow-500"></span>
            </span>
          );
        } else {
          return (
            // <span className="animate-ping bg-red-500 absolute top-0 right-0 block h-1.5 w-1.5 rounded-full opacity-75 "></span>
            <span>
              <span class="animate-ping absolute top-0.5 left-0.5 inline-flex h-2 w-2 rounded-full bg-red-500 opacity-95"></span>
              <span class="absolute top-0.5 left-0.5 block h-1.5 w-1.5 rounded-full h-1.5 w-1.5 bg-red-500"></span>
            </span>
          );
        }
      }
    } else {
      if (com == "") {
        return (
          <span className="bg-gray-300 dark:bg-gray-400 absolute top-0.5 left-0.5 block h-1.5 w-1.5 rounded-full ring-2 ring-gray-200"></span>
        );
      } else {
        <span className="bg-red-500 absolute top-0.5 left-0.5 block h-1.5 w-1.5 rounded-full ring-2 ring-white"></span>;
      }
    }
  };

  const etatPhone4 = () => {
    if (showetat == "use") {
      return (
        // <span className="animate-ping bg-red-500 absolute top-0 right-0 block h-1.5 w-1.5 rounded-full opacity-75 "></span>
        <span>
          <span class="animate-ping absolute top-0.5 left-0.5 inline-flex h-2 w-2 rounded-full bg-red-500 opacity-95"></span>
          <span class="absolute top-0.5 left-0.5 block h-1.5 w-1.5 rounded-full h-1.5 w-1.5 bg-red-500"></span>
        </span>
      );
    }
    if (showetat == "idle") {
      return (
        // <span className="animate-ping bg-red-500 absolute top-0 right-0 block h-1.5 w-1.5 rounded-full opacity-75 "></span>
        <span>
          {" "}
          <span
            class="absolute top-0.5 left-0.5 block h-1.5 w-1.5 rounded-full  opacity-75"
            style={{ backgroundColor: "#62bd19" }}
          ></span>
          <span
            className=" absolute top-0.5 left-0.5 block h-1.5 w-1.5 rounded-full ring-2 ring-white"
            style={{ backgroundColor: "#62bd19" }}
          ></span>
        </span>
      );
    }
    if (showetat == "Ringing") {
      return (
        // <span className="animate-ping bg-red-500 absolute top-0 right-0 block h-1.5 w-1.5 rounded-full opacity-75 "></span>
        <span>
          <span class="animate-ping absolute top-0.5 left-0.5 inline-flex h-2 w-2 rounded-full bg-yellow-500 opacity-95"></span>
          <span class="absolute top-0.5 left-0.5 block h-1.5 w-1.5 rounded-full h-1.5 w-1.5 bg-yellow-500"></span>
        </span>
      );
    }
  };
  function winClose(url) {
    var win = window.open("", getWinName(url));
    win.close();
  }
  function getWinName(url) {
    return "win" + url.replace(/[^A-Za-z0-9\-\_]*/g, "");
  }

  const [showetat, setshowetat] = useState("");

  // The ref object is a generic container whose current property is mutable ...
  // ... and can hold any value, similar to an instance property on a class
  // Store current value in ref

  //////////////////////context function /////////////
  // function setglobalcollegue(etat) {
  //   var itab = state.posts;
  //   var index = itab.findIndex((x) => x.poste == props.collegue.poste);
  //   itab[index].encom = etat;
  //   dispatch({ type: "SET_POSTS", payload: itab });
  // }
  // const tabcontact2 = localStorage.getItem("tabcontact");

  useEffect(() => {
    finditemincollegue();
    state?.socket?.on("FromAPI", (data) => {
      //console.log(data);
      if (data.compte !== compte) return;

      if (data.poste == collegue) {
        if (data.EtatCommunication == "InUse") {
          setshowetat("use");
          var yo = "En com";
        }
        if (data.EtatCommunication == "Idle") {
          // console.log(data.poste);
          //console.log(data.EtatCommunication);
          setshowetat("idle");
          var yo = "";
        }
        if (data.EtatCommunication == "Ringing") {
          //console.log(data.poste);
          // console.log(data.EtatCommunication);
          // if (data.poste == poste) {
          //   document.getElementsByClassName("rtf")[0].classList.add("open");
          // }

          var ring = "Ringing";
          setshowetat(ring);

          // console.log(data.poste);

          // console.log(showetat, data.poste);
          var yo = "Sonnerie";
        }
      }
    });
    return () => {
      state?.socket?.off("FromAPI");
    };
  }, []);
  return (
    <div className="inline-block h-8 w-8 rounded-full  dark:bg-gray-800">
      {/* <ReactTooltip
        id="coo"
        place="top"
        effect="solid"
        data-background-color="yellow"
      >
        {nom}
      </ReactTooltip> */}
      <span
        className="flex-shrink-1 inline-block relative"
        data-tip
        data-for="coo"
      >
        <span className="inline-block h-8 h-8 rounded-full dark:bg-gray-800 border border-gray-300 overflow-hidden bg-gray-100 dark:bg-gray-900">
          {imgsrc ? (
            <img
              data-for="coo"
              class="h-full w-full rounded-full"
              src={`${imgsrc2}`}
            />
          ) : (
            <div data-for="coo">
              <svg
                className="h-full w-full text-gray-300 dark:text-gray-400"
                fill="currentColor"
                viewBox="0 0 24 24"
              >
                <path d="M24 20.993V24H0v-2.996A14.977 14.977 0 0112.004 15c4.904 0 9.26 2.354 11.996 5.993zM16.002 8.999a4 4 0 11-8 0 4 4 0 018 0z"></path>
              </svg>
            </div>
          )}
        </span>

        {showetat ? etatPhone4(showetat) : etatPhone1(etat, encom)}
      </span>
    </div>
  );
}
export default withTranslation("common")(Colleguegroupesmall);
